// extracted by mini-css-extract-plugin
export default {"base":"SearchCriteria_base__rCkvR","remove":"SearchCriteria_remove__xKGta"};